import {
    Button,
    HStack,
    IconButton,
    Select,
    useMediaQuery,
} from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";

interface AppPaginationProps {
    onClick: (pageNumber: number) => void;
    totalPages: number;
    activePage?: number;
}

export const AppPagination = ({
    onClick,
    totalPages,
    activePage = 1,
}: AppPaginationProps) => {
    const [isSmallerThan680] = useMediaQuery("(max-width: 680px)");

    let start = activePage - 4;
    if (start < 1) {
        start = 1;
    }

    let end = activePage + 4;
    if (end > totalPages) {
        end = totalPages;
    }

    if (isSmallerThan680) {
        start = 1;
        end = totalPages;
    }

    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    const onClickHandler = (pageNumber: number) => {
        if (pageNumber < 1 || pageNumber > totalPages) {
            return;
        }
        onClick(pageNumber);
    };

    return (
        <>
            <HStack
                w={"full"}
                justifyContent="space-between"
                alignItems="center"
                backgroundColor={"var(--chakra-colors-primaryT95)"}
                border={"1px solid var(--chakra-colors-primaryT80) !important"}
                borderRadius={"0.25rem"}
                padding={"0.75rem"}
            >
                <IconButton
                    w={"33px"}
                    h={"33px"}
                    aria-label="arrow-left"
                    variant={"outline"}
                    icon={<AppIcon name="icl-arrow-left" w="0.90rem" />}
                    onClick={() => onClickHandler(activePage - 1)}
                />
                {isSmallerThan680 ? (
                    <Select
                        size={"md"}
                        w={"4.375rem"}
                        value={activePage}
                        onChange={(event) => {
                            onClickHandler(Number(event.currentTarget.value));
                        }}
                    >
                        {pages?.map((value) => (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        ))}
                    </Select>
                ) : (
                    <HStack gap={"0.375rem"}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                h="33px"
                                p={"0.75rem !important"}
                                fontSize={"0.75rem"}
                                variant={
                                    activePage === page ? "primary" : "outline"
                                }
                                onClick={() => onClickHandler(page)}
                            >
                                {page}
                            </Button>
                        ))}
                    </HStack>
                )}
                <IconButton
                    w={"33px"}
                    h={"33px"}
                    aria-label="arrow-right"
                    variant={"outline"}
                    icon={<AppIcon name="icl-arrow-right" w="0.90rem" />}
                    onClick={() => onClickHandler(activePage + 1)}
                />
            </HStack>
        </>
    );
};
